module.exports = __webpack_public_path__ + "img/open22.fef60633.png";